module.exports = __webpack_public_path__ + "static/css3-df42c20c48409ec64c5b2e19ebcfef1e.png";